import { render, staticRenderFns } from "./ac4.vue?vue&type=template&id=68822372&scoped=true&"
import script from "./ac4.vue?vue&type=script&lang=js&"
export * from "./ac4.vue?vue&type=script&lang=js&"
import style0 from "./ac4.vue?vue&type=style&index=0&id=68822372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68822372",
  null
  
)

export default component.exports